import { DataFlowSink } from 'app/model/dataflow/dataflow-sink';
import { DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { OnPremiseSqlServerSettings } from 'app/model/dataflow/dataset-settings/on-premise-sql-server-settings';
import { Dataset, DataFlowDSLAdapterRegistry, LinkedService, Metamodel, Owned } from 'shell-models-lib';
import { BaseSqlFormatAdapter } from 'app/model/adapters/dataflow/formatAdapters/sql-base.adapter';
import { DatasetUtils } from 'app/model/dataset/dataset.utils';
import { DatasetFormatType, DataFlowDatasetSettings } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { DataFlowAdapterUtils } from '../adapter.util';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(OnPremiseSqlServerSettings)
})
export class OnPremiseSqlServerFormatAdapter extends BaseSqlFormatAdapter {
    /**
     * Supplements missing DSL properties for Fabric Migration.
     */
    public supplementPropsForFabricMigration(dataset: Dataset | undefined, linkedService: LinkedService | undefined, props: string[], isSource: boolean, isInline: boolean, _datasetSettings: DataFlowDatasetSettings | undefined, format?: string): void {
        if (linkedService) {
            const dbName = DatasetUtils.getDatabaseFromLinkedService(linkedService);
            if (dbName) {
                props.push(`database: ${DataFlowAdapterUtils.formatExpressionValue(dbName)}`);
            }
        }

        if (isInline || !dataset) {
            return;
        }

        props.push(`store: '${DatasetFormatType.SqlDB}'`);

        DataFlowAdapterUtils.supplementSqlSchemaAndTableFromDataset(dataset, props, isSource, format);
    }

    protected async toSourceDSL(onPremiseSqlServerSettings: OnPremiseSqlServerSettings): Promise<string[]> {
        return super.toSourceDSL(onPremiseSqlServerSettings);
    }

    protected async toSinkDSL(onPremiseSqlServerSettings: OnPremiseSqlServerSettings): Promise<string[]> {
        return super.toSinkDSL(onPremiseSqlServerSettings);
    }

    protected async toSourceModel(
        owner: DataFlowSource,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<OnPremiseSqlServerSettings> {
        const onPremiseSqlServerSettings = Owned.create<OnPremiseSqlServerSettings>(
            OnPremiseSqlServerSettings.MODEL,
            owner
        );
        onPremiseSqlServerSettings.initialize(undefined);
        await super.toSourceModel(owner, configs, handledConfigs, onPremiseSqlServerSettings);
        return onPremiseSqlServerSettings;
    }

    protected async toSinkModel(
        owner: DataFlowSink,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<OnPremiseSqlServerSettings> {
        const onPremiseSqlServerSettings = Owned.create<OnPremiseSqlServerSettings>(
            OnPremiseSqlServerSettings.MODEL,
            owner
        );
        onPremiseSqlServerSettings.initialize(undefined);
        await super.toSinkModel(owner, configs, handledConfigs, onPremiseSqlServerSettings);
        return onPremiseSqlServerSettings;
    }
}
